/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React from 'react';
import { FlagsBoundary } from '@jira/platform__flags-boundary/src/FlagsBoundary.tsx';
import { type AsyncAutoDismissFlagProps, CommonFlag } from '../index.tsx';

const AkAutoDismissFlag = ({
	packageName = 'flags',
	...props
}: AsyncAutoDismissFlagProps): React.JSX.Element => (
	<FlagsBoundary packageName={packageName}>
		<CommonFlag isAutoDismiss {...props} flagType="info" />
	</FlagsBoundary>
);

export default AkAutoDismissFlag;
